export default __webpack_public_path__ + "static/media/bridges.58d7d2cb.png";